import React from 'react'
import { useIntl } from 'react-intl'
import MessageBox from 'src/comps/MessageBox'
import { INVOICE_STATUS, InvoicePanelStatus } from '../types'
import styles from './index.module.css'

interface StatusBadgeProps {
  date?: Date | string
  type: InvoicePanelStatus
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ date, type }) => {
  const intl = useIntl()

  if (!date) return null

  const isRequested = type === INVOICE_STATUS.REQUESTED

  return (
    <div className={styles.statusBadge}>
      <MessageBox
        message={intl.formatMessage(
          { id: isRequested ? 'invoice.requested' : 'invoice.sent' },
          {
            date: intl.formatDate(date, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }),
            time: intl.formatTime(date),
          }
        )}
        type="success"
      />
    </div>
  )
}

export default StatusBadge
